import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import {
  preferencesLandingPlacesFeatureKey,
  reducer,
} from './preference-landing-places.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(preferencesLandingPlacesFeatureKey, reducer),
  ],
})
export class PreferenceLandingPagesModule {}
